<template>



    <!-- SIDE NAV -->
    <div class="sidenav" :class="{ 'mob-open': navOpen, 'collapsed': navCollapsed }">
        <div class="sn-logo" style="display:flex;align-items:center;">

            <img src="@/assets/white_logo.svg" alt="Succour Logo" style="
            width:150px;
            height:38px;
            object-fit:contain;
            display:block;
        " />

        </div>

        <div class="sn-sec">Overview</div>
        <a class="sn-item active" href="#" @click.prevent="navTo('registry')">
            <span class="sn-icon">🏠</span><span class="sn-lbl">Registry Pulse</span>
        </a>
        <a class="sn-item" href="#" @click.prevent="navTo('ops')">
            <span class="sn-icon">✅</span><span class="sn-lbl">Ops Queue</span><span class="sn-badge">23</span>
        </a>

        <div class="sn-sec">Quality</div>
        <a class="sn-item" href="#" @click.prevent="navTo('trust')">
            <span class="sn-icon">🛡</span><span class="sn-lbl">Trust Score Health</span><span class="sn-badge">6</span>
        </a>
        <a class="sn-item" href="#" @click.prevent="navTo('employer')">
            <span class="sn-icon">👤</span><span class="sn-lbl">Employer Activity</span>
        </a>

        <div class="sn-sec">System</div>
        <a class="sn-item" href="#" @click.prevent="navTo('alerts')">
            <span class="sn-icon">🔔</span><span class="sn-lbl">Alerts</span><span class="sn-badge">5</span>
        </a>
        <a class="sn-item" href="#" @click.prevent="navTo('alerts')">
            <span class="sn-icon">⚙️</span><span class="sn-lbl">API & Engine Status</span>
        </a>

        <div class="sn-footer">
            <button class="sn-toggle" @click="toggleNav">
                <span style="font-size:15px;flex-shrink:0;">
                    {{ navCollapsed ? '▶' : '◀' }}
                </span>

                <span v-if="!navCollapsed">Collapse</span>
            </button>
        </div>
    </div>

    <!-- LAYOUT -->
    <div class="layout" :class="{ 'nav-sm': navCollapsed }">
        <div class="topbar">
            <button class="tb-burger" @click="openMob()">☰</button>
            <span class="tb-title">Internal Dashboard · v2</span>
            <div class="tb-r">
                <span class="live">LIVE</span>
                <span class="ttime" id="clk">{{ clock }}</span>
                <span class="abadge">Admin</span>
                <button class="logout-btn" @click="logout">
                    <span class="logout-icon">↩</span>
                    <span>Logout</span>
                </button>
            </div>
        </div>

        <div class="main">

            <slot></slot>

            <div
                style="text-align:center;padding:18px 0 6px;border-top:1px solid #E2EDE7;margin-top:8px;font-size:10px;color:#6B8F78;letter-spacing:1px;">
                SUCCOUR CARE REGISTRY™ · INTERNAL USE ONLY · ADMIN ACCESS · www.succour.care
            </div>
        </div>
    </div>
</template>

<script lang="js">
import { useAuthStore } from "@/stores/auth";
import Request from "@/utils/apiclient";
export default {
    data() {
        return {
            // CLOCK
            clock: '',
            date: '',
            timer: null,
            navOpen: false,
            navCollapsed: false,
            activeNav: null,
        }
    },
    mounted() {
        // CLOCK
        this.tick()

        this.timer = setInterval(() => {
            this.tick()
        }, 1000)

    },
    methods: {
        // =======================
        // CLOCK
        // =======================


        async logout() {

            const authStore = useAuthStore();

            try {
                const request = new Request("/auth/logout/");

                await new Promise((resolve) => {
                    request.post({}, () => resolve(), false);
                });

            } catch (e) {
                console.log("Logout error:", e);
            }

            authStore.logout();

            localStorage.clear();
            sessionStorage.clear();

            this.$router.replace("/login");
        },
        tick() {
            const n = new Date()

            this.clock = n.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })

            this.date = n.toLocaleDateString('en-GB', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            })
        },

        // =======================
        // NAVIGATION
        // =======================
        toggleNav() {
            this.navCollapsed = !this.navCollapsed
        },

        openMob() {
            this.navOpen = !this.navOpen
        },
        closeMob() {
            this.navOpen = false
        },

        setAct(id) {
            this.activeNav = id
        },

        navTo(id) {

            this.setAct(id)
            this.closeMob()

            const target = document.getElementById(id)

            if (!target) return

            const topbar = document.querySelector('.topbar')
            const topbarH = topbar?.offsetHeight || 0

            const targetTop =
                target.getBoundingClientRect().top +
                window.scrollY -
                topbarH -
                12

            window.scrollTo({
                top: targetTop,
                behavior: 'smooth'
            })
        },

    }
}
</script>

<style lang="css" scoped>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

html {
    scroll-behavior: smooth;
}

body {
    font-family: 'Open Sans', sans-serif;
    background: #F4F7F5;
    color: #1A2E22;
    font-size: 13px;
    display: flex;
    min-height: 100vh;
}

/* ── SIDE NAV ── */
.sidenav {
    width: 220px;
    background: #0D5C40;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    transition: width .25s ease, transform .25s ease;
}

.sidenav.collapsed {
    width: 58px;
}

.sn-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 14px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, .08);
    min-height: 60px;
    overflow: hidden;
}

.sn-mark {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: #F59CAB;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
}

.sn-brand-name {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #fff;
    white-space: nowrap;
}

.sn-brand-sub {
    font-size: 8px;
    color: rgba(255, 255, 255, .35);
    letter-spacing: 1px;
    margin-top: 1px;
    white-space: nowrap;
}

.sidenav.collapsed .sn-brand-name,
.sidenav.collapsed .sn-brand-sub {
    display: none;
}

.sn-sec {
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, .28);
    padding: 12px 14px 4px;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
}

.sidenav.collapsed .sn-sec {
    opacity: 0;
    height: 0;
    padding: 0;
}

.sn-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 14px;
    cursor: pointer;
    color: rgba(255, 255, 255, .5);
    font-size: 12px;
    font-weight: 500;
    border-left: 3px solid transparent;
    transition: .15s;
    text-decoration: none;
    overflow: hidden;
}

.sn-item:hover {
    background: rgba(255, 255, 255, .06);
    color: rgba(255, 255, 255, .85);
}

.sn-item.active {
    background: rgba(255, 255, 255, .1);
    color: #fff;
    border-left-color: #F59CAB;
}

.sn-icon {
    font-size: 15px;
    flex-shrink: 0;
    width: 22px;
    text-align: center;
}

.sn-lbl {
    white-space: nowrap;
    flex: 1;
}

.sidenav.collapsed .sn-lbl {
    display: none;
}

.sn-badge {
    font-size: 9px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 20px;
    background: rgba(231, 76, 60, .3);
    color: #FCA5A5;
    white-space: nowrap;
}

.sidenav.collapsed .sn-badge {
    display: none;
}

.sn-footer {
    margin-top: auto;
    padding: 12px 14px;
    border-top: 1px solid rgba(255, 255, 255, .08);
    position: relative;
    z-index: 5;
}


.sn-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    color: rgba(255, 255, 255, .3);
    font-size: 11px;
    cursor: pointer;
    font-family: 'Open Sans', sans-serif;
    padding: 0;
    width: 100%;
}

.sn-toggle:hover {
    color: rgba(255, 255, 255, .7);
}



.sidenav.collapsed .sn-toggle span:last-child {
    display: none;
}

/* ── OVERLAY ── */
.overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .45);
    z-index: 150;
}

.overlay.show {
    display: block;
}

/* ── MAIN AREA ── */
.layout {
    margin-left: 220px;
    flex: 1;
    display: flex;
    flex-direction: column;
    transition: margin-left .25s ease;
    min-width: 0;
}

.layout.nav-sm {
    margin-left: 58px;
}

.layout.nav-0 {
    margin-left: 0;
}

/* ── TOPBAR ── */
.topbar {
    background: #0D5C40;
    display: flex;
    align-items: center;
    padding: 0 18px;
    height: 50px;
    gap: 12px;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 6px rgba(13, 92, 64, .18);
}

.tb-burger {
    display: none;
    background: none;
    border: none;
    color: rgba(255, 255, 255, .7);
    font-size: 20px;
    cursor: pointer;
    line-height: 1;
    padding: 2px 4px;
}

.tb-title {
    font-size: 11px;
    color: rgba(255, 255, 255, .4);
}

.tb-r {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 11px;
}

.live {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 10px;
    font-weight: 600;
    color: rgba(255, 255, 255, .6);
}

.live::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #4ADE80;
    animation: lp 2s infinite;
}

@keyframes lp {

    0%,
    100% {
        opacity: 1
    }

    50% {
        opacity: .35
    }
}

.ttime {
    font-size: 11px;
    color: rgba(255, 255, 255, .32);
}

.abadge {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 1px;
    padding: 3px 9px;
    border-radius: 20px;
    background: rgba(245, 156, 171, .18);
    color: #F59CAB;
    border: 1px solid rgba(245, 156, 171, .3);
}

.logout-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;

    padding: 6px 10px;
    border-radius: 14px;
    border: 1px solid rgba(245, 156, 171, 0.25);

    background: linear-gradient(135deg,
            rgba(245, 156, 171, 0.14),
            rgba(245, 156, 171, 0.06));

    color: #F59CAB;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;

    cursor: pointer;
    transition: all 0.25s ease;

    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.logout-btn:hover {
    transform: translateY(-1px);
    background: rgba(245, 156, 171, 0.18);
    border-color: rgba(245, 156, 171, 0.45);

    box-shadow: 0 8px 20px rgba(245, 156, 171, 0.15);
}

.logout-btn:active {
    transform: scale(0.98);
}

.logout-icon {
    font-size: 12px;
    line-height: 1;
}

/* ── CONTENT ── */
.main {
    padding: 18px 20px 48px;
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
}

.ph {
    margin-bottom: 14px;
}

.pdate {
    font-size: 10px;
    color: #6B8F78;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 2px;
}

.ptitle {
    font-size: 18px;
    font-weight: 600;
    color: #1A2E22;
}

.ptitle span {
    color: #17865F;
}

.slbl {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #6B8F78;
    margin: 16px 0 9px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.slbl::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #E2EDE7;
}

.g {
    display: grid;
    gap: 10px;
    margin-bottom: 10px;
}

.g5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
}

.g4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.g3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.g2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.g32 {
    grid-template-columns: 3fr 2fr;
}

.g21 {
    grid-template-columns: 2fr 1fr;
}

.card {
    background: #fff;
    border: 1px solid #E2EDE7;
    border-radius: 12px;
    padding: 15px 17px;
    position: relative;
    overflow: hidden;
}

.ca {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
}

.clbl {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 1.5px;
    color: #6B8F78;
    margin-bottom: 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px;
}

.cn {
    font-size: 30px;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 3px;
}

.cn.md {
    font-size: 24px;
}

.cs {
    font-size: 11px;
    color: #6B8F78;
}

.cd {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 10px;
    font-weight: 600;
    margin-top: 5px;
    padding: 2px 8px;
    border-radius: 20px;
}

.du {
    color: #17865F;
    background: #E8F4EF;
}

.dd {
    color: #E74C3C;
    background: #FEF2F2;
}

.df {
    color: #6B8F78;
    background: #F4F7F5;
}

.pl {
    font-size: 9px;
    font-weight: 600;
    padding: 2px 7px;
    border-radius: 20px;
}

.pg {
    background: #E8F4EF;
    color: #17865F;
    border: 1px solid #D0E3D8;
}

.pr {
    background: #FEF2F2;
    color: #E74C3C;
    border: 1px solid rgba(231, 76, 60, .2);
}

.pw {
    background: #FFF8EC;
    color: #A06010;
    border: 1px solid rgba(245, 166, 35, .25);
}

.pi {
    background: #EFF6FF;
    color: #2563EB;
    border: 1px solid rgba(37, 99, 235, .2);
}

.pm {
    background: #F4F7F5;
    color: #6B8F78;
    border: 1px solid #E2EDE7;
}

.py {
    background: #FFF9E6;
    color: #B8860B;
    border: 1px solid rgba(184, 134, 11, .22);
}

.trow {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 7px;
}

.trow:last-child {
    margin-bottom: 0;
}

.tlbl {
    font-size: 10px;
    font-weight: 600;
    width: 52px;
    flex-shrink: 0;
}

.ttrk {
    flex: 1;
    height: 6px;
    background: #F4F7F5;
    border-radius: 3px;
    overflow: hidden;
    border: 1px solid #E2EDE7;
}

.tfil {
    height: 100%;
    border-radius: 3px;
    transition: width 1.1s cubic-bezier(.16, 1, .3, 1);
}

.tpct {
    font-size: 11px;
    color: #6B8F78;
    width: 28px;
    text-align: right;
}

table.ot {
    width: 100%;
    border-collapse: collapse;
}

table.ot th {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 1.5px;
    color: #6B8F78;
    padding: 0 0 8px;
    text-align: left;
    border-bottom: 1px solid #E2EDE7;
}

table.ot td {
    font-size: 12px;
    padding: 8px 0;
    border-bottom: 1px solid #E2EDE7;
    vertical-align: middle;
}

table.ot tr:last-child td {
    border: none;
}

.on {
    font-weight: 600;
    color: #1A2E22;
}

.or {
    font-size: 10px;
    color: #6B8F78;
    margin-top: 1px;
}

.sigr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 0;
    border-bottom: 1px solid #E2EDE7;
}

.sigr:last-child {
    border: none;
}

.sn2 {
    font-size: 12px;
    font-weight: 600;
    color: #1A2E22;
}

.sm {
    font-size: 10px;
    color: #6B8F78;
    margin-top: 1px;
}

.sb {
    width: 56px;
    height: 4px;
    background: #F4F7F5;
    border-radius: 2px;
    overflow: hidden;
}

.sbf {
    height: 100%;
    border-radius: 2px;
}

.spc {
    font-size: 11px;
    font-weight: 600;
    width: 28px;
    text-align: right;
}

.ai {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    padding: 9px 0;
    border-bottom: 1px solid #E2EDE7;
}

.ai:last-child {
    border: none;
}

.adot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 3px;
}

.at {
    font-size: 12px;
    color: #1A2E22;
    line-height: 1.45;
    flex: 1;
}

.at strong {
    font-weight: 600;
}

.am {
    font-size: 10px;
    color: #6B8F78;
    margin-top: 2px;
}

.acta {
    font-size: 10px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #E2EDE7;
    background: #fff;
    color: #1A2E22;
    flex-shrink: 0;
    font-family: 'Open Sans', sans-serif;
    transition: .15s;
}

.acta:hover {
    background: #F4F7F5;
}

.acta.d {
    color: #E74C3C;
    border-color: rgba(231, 76, 60, .25);
}

.acta.d:hover {
    background: #FEF2F2;
}

.arow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid #E2EDE7;
}

.arow:last-child {
    border: none;
}

.an {
    font-size: 12px;
    font-weight: 600;
}

.aok {
    font-size: 10px;
    font-weight: 600;
    color: #17865F;
    display: flex;
    align-items: center;
    gap: 4px;
}

.aok::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #4ADE80;
}

.awk {
    font-size: 10px;
    font-weight: 600;
    color: #A06010;
}

.leg {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 8px;
    font-size: 11px;
    color: #6B8F78;
}

.leg span {
    display: flex;
    align-items: center;
    gap: 5px;
}

.leg i {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    flex-shrink: 0;
    display: inline-block;
}

.cw {
    position: relative;
    width: 100%;
}

.sec {
    scroll-margin-top: 68px;
}

.tbl-scroll {
    overflow-x: auto;
}

/* ── RESPONSIVE ── */
@media(max-width:1060px) {
    .g5 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .g4 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .g32,
    .g21 {
        grid-template-columns: 1fr;
    }
}

@media(max-width:860px) {
    .sidenav {
        width: 58px;
    }

    .sidenav .sn-brand-name,
    .sidenav .sn-brand-sub,
    .sidenav .sn-sec,
    .sidenav .sn-lbl,
    .sidenav .sn-badge,
    .sidenav .sn-toggle span {
        display: none;
    }

    .sidenav .sn-sec {
        opacity: 0;
        height: 0;
        padding: 0;
    }

    .layout {
        margin-left: 58px;
    }

    .layout.nav-0 {
        margin-left: 0;
    }
}

@media(max-width:600px) {
    .sidenav {
        transform: translateX(-100%);
        width: 220px;
    }

    .sidenav.mob-open {
        transform: translateX(0);
    }

    .sidenav.mob-open .sn-brand-name,
    .sidenav.mob-open .sn-brand-sub,
    .sidenav.mob-open .sn-sec,
    .sidenav.mob-open .sn-lbl,
    .sidenav.mob-open .sn-badge,
    .sidenav.mob-open .sn-toggle span {
        display: block;
    }

    .sidenav.mob-open .sn-sec {
        opacity: 1;
        height: auto;
        padding: 12px 14px 4px;
    }

    .layout,
    .layout.nav-sm {
        margin-left: 0;
    }

    .tb-burger {
        display: block;
    }

    .g5,
    .g4,
    .g3 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .g2,
    .g32,
    .g21 {
        grid-template-columns: 1fr;
    }

    .main {
        padding: 12px 12px 36px;
    }
}

@media(max-width:360px) {

    .g5,
    .g4,
    .g3,
    .g2 {
        grid-template-columns: 1fr;
    }
}
</style>